import api from './api';

export const CustomersService = {
    list: async (search = '') => {
        const data = (await api.get('/customers', { params: { search } })).data;
        return Array.isArray(data) ? data : data.items || [];
    },
    listPage: async (params = {}) => (await api.get('/customers', { params: { ...params, paginated: true } })).data,
    create: async (payload) => (await api.post('/customers', payload)).data,
};

export const LocationsService = {
    departments: async () => (await api.get('/locations/departments')).data,
};

export const JewelryService = {
    listPage: async (params = {}) => (await api.get('/jewelry', { params })).data,
    list: async (params = {}) => {
        const firstPage = params.page || 1;
        const limit = params.limit || 200;
        const firstData = (await api.get('/jewelry', { params: { ...params, page: firstPage, limit } })).data;
        if (Array.isArray(firstData)) return firstData;
        if (params.page || params.limit) return firstData.items || [];

        const rows = [...(firstData.items || [])];
        for (let page = firstPage + 1; page <= (firstData.pages || 1); page += 1) {
            const nextData = (await api.get('/jewelry', { params: { ...params, page, limit } })).data;
            rows.push(...(nextData.items || []));
        }
        return rows;
    },
    publicCatalog: async (params = {}) => (await api.get('/jewelry/public/catalog', { params })).data,
    get: async (id) => (await api.get(`/jewelry/${id}`)).data,
    create: async (payload) => (await api.post('/jewelry', payload)).data,
    update: async (id, payload) => (await api.patch(`/jewelry/${id}`, payload)).data,
    delete: async (id) => (await api.delete(`/jewelry/${id}`)).data,
    exportUrl: () => `${api.defaults.baseURL}/jewelry/export`,
};

export const SalesService = {
    list: async (params = {}) => {
        const data = (await api.get('/sales', { params })).data;
        return Array.isArray(data) ? data : data.items || [];
    },
    listPage: async (params = {}) => (await api.get('/sales', { params: { ...params, paginated: true } })).data,
    listAll: async (params = {}) => (await api.get('/sales', { params: { ...params, all: true, limit: params.limit || 10000 } })).data,
    create: async (payload) => (await api.post('/sales', payload)).data,
    update: async (id, payload) => (await api.patch(`/sales/${id}`, payload)).data,
    updateStatus: async (id, status) => (await api.patch(`/sales/${id}/status`, { status })).data,
    delete: async (id) => (await api.delete(`/sales/${id}`)).data,
};

export const ReportsService = {
    dashboard: async () => (await api.get('/reports/dashboard')).data,
    financialSummary: async (params = {}) => (await api.get('/reports/financial-summary', { params })).data,
};
